import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sd-bottom-sheet-footer',
  templateUrl: './bottom-sheet-footer.component.html',
  styleUrls: ['./bottom-sheet-footer.component.scss']
})
export class BottomSheetFooterComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
